<template>
  <div class="select-wrapper">
    <select
      id="include-suburb-answer"
      :class="classes"
      :disabled="disabled"
      :value="value"
      @change="$emit('input', $event.target.value)">
      <!-- <option value="" disabled>Please select...</option> -->
      <option
        v-for="option in options"
        :key="option.value"
        :value="option.value">
        {{ option.text }}
      </option>
    </select>
  </div>
</template>

<script>

export default {
  name: 'SelectList',
  props: {
    options: {
      type: Array,
      required: true,
    },
    classes: {
      default: () => ([]),
      required: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    value: {
      required: false,
      default: 0,
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">

.select-wrapper {
  // @apply ut-relative;

  select {
    @apply ut-py-2 ut-px-4 ut-pr-8 ut-bg-no-repeat ut-bg-contain;
    font-size: 14px;
    line-height: 18px;
    border: 1px solid #979797;
    background-color: #F7F5F3;
    border-radius: 3px;
    appearance: none;
    background-position: right center;
    background-image: url('../../assets/styles/frontend-library/images/arrow-down.svg');
    width: inherit;

    //IE fix to remove default select list arrow
    &::-ms-expand {
      display: none;
    }

    &:focus {
      outline-width: 0;
      @apply ut-border ut-border-green-400;
      box-shadow: 0 0 0 1px rgba(78, 182, 72, .16), inset 0 0 0 1px theme('colors.green.400');
    }
  }
}

.custom {
  padding: 16px !important;
}
</style>
